import { makeStyles } from '@fluentui/react-components';

import { customTokens } from 'src/utils/theme';

export const useCardLayoutContainerStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  header: {
    height: customTokens.spacingVertical10XL,
    display: 'flex',
  },
  content: {
    display: 'flex',
  },
});
